import { useAnchorable } from '../../hooks/useAnchorable';
import { audioContainer } from './Audio.css';
import type { TPostAudioProps } from './Audio.types';

export const PostAudio = (props: TPostAudioProps) => {
  const { element } = props;
  const { attrs } = element;
  const { anchorAttributes } = useAnchorable(attrs);

  return (
    <div {...anchorAttributes} className={audioContainer}>
      <iframe
        src={attrs.data?.iframe_src}
        title="Post audio player"
        className="w-full h-[162px]"
        allow="encrypted-media"
      />
    </div>
  );
};
